const React = require("react");
const { NavLink, Outlet } = require("react-router-dom");
const { usePrintful } = require("../context/PrintfulContext");
const { getPrintfulNavigation } = require("../navigation");
const { PRINTFUL_CSS } = require("../styles");
const h = React.createElement;

const PrintfulLayout = () => {
  const { t, isAdmin } = usePrintful();
  return h("div", { className: "pfds-shell" }, h("style", null, PRINTFUL_CSS),
    h("header", { className: "pfds-top" }, h("h1", null, t("h_pf_title", "Printful Dropshipping")), h("p", null, t("h_pf_subtitle", "Connect your store, import designed products and automate fulfillment."))),
    h("nav", { className: "pfds-nav", "aria-label": t("h_pf_navigation", "Printful navigation") }, ...getPrintfulNavigation(t, { isAdmin }).map((item) => h(NavLink, { key: item.to, to: item.to, className: ({ isActive }) => isActive ? "active" : "" }, item.label))),
    h("main", { className: "pfds-main" }, h(Outlet))
  );
};
module.exports = { PrintfulLayout };
